import firebase from '../../firebase/compat'
import callWithColdStartRetry from './callWithColdStartRetry'
import whenAuthKnown from '../auth/whenAuthKnown'

/**
 * Haal de thema's (doelgroep × effect) op voor de beheertenant. Dit zijn ÁLLE
 * afgeleide thema's, ook die zonder gepubliceerd inzicht — daar werk je aan.
 * De publieke API toont alleen thema's die al buiten staan.
 *
 * De afleiding doet een cross-tenant scan op een functie die naar nul schaalt,
 * dus de eerste aanroep na stilte strandt soms op een koude start. Dan ziet de
 * gebruiker 'konden niet worden geladen: internal', en dat leest als kapot
 * terwijl het een opstartende container is. Eén herkansing, alleen bij codes van
 * voorbijgaande aard -- een permission-denied gaat er meteen door.
 *
 * @param {{delayMs?: number}} [opties] - alleen om in tests niet echt te wachten
 * @returns {Promise<{themes: Array<object>}>}
 */
export const fetchThemes = async (opties = {}) => {
    // Eerst weten wie er ingelogd is. Bij een harde herlaad herstelt Firebase de
    // sessie asynchroon, en getThemes ziet dan `auth: MISSING` en weigert -- in
    // de logs stonden zes van die weigeringen binnen een paar milliseconden.
    // Uitgelogd geeft null en de aanroep gaat door: een echte permission-denied
    // hoort zichtbaar te zijn.
    await whenAuthKnown()
    const callable = firebase.app().functions('europe-west1').httpsCallable('getThemes')
    const result = await callWithColdStartRetry(callable, {}, opties)
    return result.data
}

export default fetchThemes
